<header class="shadow-sm px-6 py-4 flex items-center justify-between">

  <!-- Left -->
  <div class="flex items-center gap-4">

    <button
      (click)="layout.toggleMobileSidebar()"
      class="btn-close-nav_Movil lg:hidden p-2 rounded-lg hover:bg-gray-100"
    >
      <i class="pi pi-bars"></i>
    </button>

    <div class="relative hidden sm:block">
      <input
        type="text"
        [placeholder]="'common.header.searchPlaceholder' | transloco"
        (input)="onSearchInput($event)"
        class="w-96 pl-4 pr-10 py-2 rounded-full border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      <i class="pi pi-search absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"></i>
    </div>

  </div>

  <!-- Right -->
  <div class="flex items-center gap-6">

    <div class="hidden md:flex items-center gap-2">
      <label for="header-language-selector" class="text-xs font-medium text-gray-700">
        {{ 'common.language.label' | transloco }}
      </label>
      <select
        id="header-language-selector"
        class="select-custom pl-3 pr-8 py-1 rounded-full border border-gray-300 text-xs text-gray-700 focus:border-primary focus:outline-none"
        (change)="onLanguageChange($event)"
      >
        @for (language of languages; track language.value) {
          <option [value]="language.value" [selected]="language.value === activeLanguage">{{ language.label }}</option>
        }
      </select>
    </div>

    <button
      type="button"
      class="p-2 rounded-full text-gray-500 hover:bg-gray-100"
      [attr.aria-label]="(themeService.theme() === 'dark' ? 'common.theme.toLight' : 'common.theme.toDark') | transloco"
      (click)="themeService.toggle()"
    >
      <i class="pi" [class.pi-moon]="themeService.theme() === 'light'" [class.pi-sun]="themeService.theme() === 'dark'"></i>
    </button>

    <app-notification-panel />

    <div class="border-l-2 border-gray-200 h-[30px]"></div>

    <!-- Profile -->
    <div class="relative dropdown-container">

      <button (click)="toggleDropdown($event)" class="flex items-center gap-2 hover:bg-gray-200 px-3 py-2 rounded-full">
        <img
          [src]="currentUser()?.avatarUrl"
          [attr.alt]="currentUser()?.fullName"
          class="w-8 h-8 rounded-full object-cover"
        />
        <div class="text-left hidden sm:block">
          <p class="text-sm font-medium">{{ currentUser()?.fullName }}</p>
          <p class="text-xs text-gray-500">{{ currentUser()?.role }}</p>
        </div>
        <i
          class="ml-2 pi pi-angle-down text-gray-500 transition-transform duration-200"
          [class.rotate-180]="layout.isDropdownOpen()"
        ></i>
      </button>

      @if (layout.isDropdownOpen()) {
        <div class="absolute right-0 mt-2 p-2 grid gap-1 w-52 bg-white rounded-2xl shadow-lg border z-50">

          <!-- Info del usuario -->
          <div class="px-4 py-2 border-b border-gray-100 mb-1">
            <p class="text-xs font-semibold text-gray-800 truncate">{{ currentUser()?.fullName }}</p>
            <p class="text-xs text-gray-400 truncate">{{ currentUser()?.organization?.name }}</p>
          </div>

          <a routerLink="/profile" (click)="layout.closeDropdown()" class="flex items-center gap-2 px-4 py-2 text-sm text-gray-500 hover:bg-gray-100 rounded-lg">
            <i class="pi pi-user text-sm"></i> {{ 'common.header.menu.profile' | transloco }}
          </a>

          <button
            (click)="onLogout()"
            class="flex items-center gap-2 w-full text-left px-4 py-2 text-sm text-red-500 hover:bg-red-50 rounded-lg"
          >
            <i class="pi pi-sign-out text-sm"></i> {{ 'common.header.menu.logout' | transloco }}
          </button>

        </div>
      }

    </div>

  </div>

</header>
